/**
 * @description iframe通信模块
 * @author duanjun
 * @date 2017.03.29
 */

function PostMessager(data) {
    this.__callId = 0;
    this.__callbacks = {};
    this.__listeners = [];
    this.domain = data.domain;
    this.receiver = data.receiver;

    this._receive = this._receive.bind(this);
    this._bindEvent();
}

PostMessager.prototype._bindEvent = function () {
    window.addEventListener('message', this._receive, false);
};

PostMessager.prototype._post = function (data) {
    this.receiver.postMessage(data, this.domain);
};

PostMessager.prototype._receive = function (event) {
    var data = event.data || {};
    var __callId = data.__callId;
    var __from = data.__from;
    if (__from !== 'umu') {
        return;
    }
    var self = this;
    if (__callId) {
        //说明是自己发的, 这个时候就需要调用回掉了，而不是分发
        if (this.__callbacks[this.__callId]) {
            this.__callbacks[this.__callId](data);
            // 数据消费后再销毁，避免多个channel的的处理次序不同
            delete data.__from;
            delete data.__callId;
            return;
        }
    }
    this.__listeners.forEach(function (listenFunc) {
        listenFunc(data.data, function (response) {
            response && self._post(Object.assign(response, { __callId: __callId, __from: 'umu' }));
        });
    });
};

PostMessager.prototype.send = function (data, callback) {
    var param = Object.assign(data, {
        __from: 'umu'
    });
    if (callback) {
        this.__callId += 1;
        this.__callbacks[this.__callId] = callback;
        param = Object.assign({}, data, {
            __callId: this.__callId
        });
    }

    this._post(param, callback);
};

PostMessager.prototype.listen = function (callback) {
    this.__listeners.push(callback);
};

PostMessager.prototype.destroy = function () {
    window.removeEventListener('message', this._receive, false);
};

export default PostMessager;
